module.exports = __webpack_public_path__ + "media/MapToggle/pin-e67946da.svg";